import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=55d3b0f9&scoped=true"
import script from "./declaration.vue?vue&type=script&lang=js"
export * from "./declaration.vue?vue&type=script&lang=js"
import style0 from "./declaration.vue?vue&type=style&index=0&id=55d3b0f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3b0f9",
  null
  
)

export default component.exports